
import Vue from 'vue'

import JcdcNavRouterMobile from '@/components/jcdc/JcdcNavRouterMobile.vue'
import JcdcNavRouterDesktop from '@/components/jcdc/JcdcNavRouterDesktop.vue'
import { navList, userInfo, utilityItem } from '@/util/navUtilities'

export default Vue.extend({
  name: 'JcdcNavRouter',
  components: {
    JcdcNavRouterMobile,
    JcdcNavRouterDesktop,
  },
  props: {
    navList: { type: Array as () => navList[], required: true },
    userInfo: { type: Object as () => userInfo, required: true },
    utilityList: { type: Array as () => utilityItem[], default: (): [] => [] },
    appTitle: { type: String, required: true },
    infoDate: { type: [String, Date, Number, Object], default: undefined },
  },
  data() {
    return {}
  },
  methods: {
    linkClick(event) {
      this.$emit(`${event}-click`, event)
    },
  },
})
